import React from 'react';
import glamorous from 'glamorous';


import TaraAvatar from './TaraAvatar';
import TaraText from './TaraText';

const Container = glamorous.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'fixed',
  bottom: 8,
  left: 8,
  padding: 4,
  width: 56,
  height: 56,
  backgroundColor: '#fff',
  borderRadius: '50%',
  border: `2px solid ${theme.primary.base}`,
  boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
  cursor: 'pointer',
}));

class TaraFloatingActionButton extends React.PureComponent {
  render() {
    return (
      <Container onClick={this.props.onClick}>
        <TaraAvatar
          marginRight={0}
          width={36}
        />
      </Container>
    );
  }
}

export default TaraFloatingActionButton;



// WEBPACK FOOTER //
// ./src/components/features/Tara/TaraFloatingActionButton.js